import { render, staticRenderFns, recyclableRender, components } from "./visitorApplication.vue?vue&type=template&id=67647f06&scoped=true&"
var renderjs
import script from "./visitorApplication.vue?vue&type=script&lang=js&"
export * from "./visitorApplication.vue?vue&type=script&lang=js&"
import style0 from "./visitorApplication.vue?vue&type=style&index=0&lang=css&"
import style1 from "./visitorApplication.vue?vue&type=style&index=1&id=67647f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67647f06",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/visitorApplication/visitorApplication.vue"
export default component.exports